import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer, FileDown, Download } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { LogoFull } from "@/components/Logo";
import { GoldButton, GhostButton } from "@/components/common";
import { downloadOrderCsv, downloadOrderPdf } from "@/components/SupplierOrder";

export default function OrderPrint() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then((r) => { setO(r.data); document.title = `Ordine ${r.data.number} - Estetica e Benessere`; }); }, [id]);
  if (!o) return null;
  const total = o.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <div className="min-h-screen bg-[#F6F1EA] print:bg-white py-10 print:py-0" data-testid="order-print-page">
      <div className="mx-auto mb-6 flex max-w-3xl justify-end gap-2 px-4 print:hidden">
        <GhostButton onClick={() => downloadOrderCsv(o)} data-testid="order-print-csv"><FileDown className="h-4 w-4" /> Excel</GhostButton>
        <GoldButton onClick={() => downloadOrderPdf(o)} data-testid="order-download-pdf"><Download className="h-4 w-4" /> Scarica PDF</GoldButton>
        <GhostButton onClick={() => window.print()} data-testid="order-print-now"><Printer className="h-4 w-4" /> Stampa</GhostButton>
      </div>
      <div className="mx-auto max-w-3xl bg-[#FDFBF7] px-5 sm:px-10 py-12 shadow-[0_10px_30px_-10px_rgba(18,18,18,0.12)] print:shadow-none print:max-w-none">
        <header className="flex flex-wrap items-start justify-between gap-4 border-b border-[#C5A059]/50 pb-8">
          <LogoFull className="w-40 sm:w-64 rounded-xl" />
          <div className="text-right text-sm">
            <div className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">Ordine prodotti</div>
            <div className="font-mono text-[#121212]" data-testid="order-print-number">{o.number}</div>
            <div className="text-[#6E675F]">{fmtDate(o.created_at)}</div>
          </div>
        </header>
        <section className="mt-8 text-sm">
          <div className="text-xs uppercase tracking-[0.2em] text-[#6E675F]">Spett.le fornitore</div>
          <div className="mt-1 font-serif text-2xl text-[#121212]" data-testid="order-print-supplier">{o.supplier || "—"}</div>
          <p className="mt-3 text-[#6E675F]">Con la presente richiediamo la fornitura dei seguenti prodotti:</p>
        </section>
        <table className="mt-6 w-full text-sm">
          <thead>
            <tr className="border-b border-[#121212] text-left text-xs uppercase tracking-[0.14em] text-[#6E675F]">
              <th className="py-2 font-normal">#</th><th className="py-2 font-normal">Prodotto</th><th className="py-2 font-normal">Marca</th><th className="py-2 text-right font-normal">Quantità</th>
            </tr>
          </thead>
          <tbody>
            {o.items.map((i, k) => (
              <tr key={k} className="border-b border-[#E8E1D7]">
                <td className="py-3 text-[#9E958A]">{k + 1}</td>
                <td className="py-3 text-[#121212]">{i.name}</td>
                <td className="py-3 text-[#6E675F]">{i.brand || "—"}</td>
                <td className="py-3 text-right font-medium" data-testid={`order-print-qty-${k}`}>{i.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-4 text-right text-sm">Totale pezzi: <span className="font-serif text-2xl">{total}</span></div>
        {o.notes && <p className="mt-8 whitespace-pre-line text-sm text-[#6E675F]">{o.notes}</p>}
        <footer className="mt-16 flex justify-between text-xs text-[#9E958A]">
          <span>Grazie, cordiali saluti</span>
          <span>Estetica e Benessere di Micol Pennacchietti</span>
        </footer>
      </div>
    </div>
  );
}
